module.exports = __webpack_public_path__ + "img/bikkurapon_target_us.029cfb15.png";